import React, { useCallback } from "react";
import { useMutation } from "react-query";
import Axios from "axios";
import {
  antdMessageError,
  antdMessageInfo,
} from "../../../../../helpers/Utils";
import { FiUpload } from "react-icons/fi";
import { Button } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import { useDropzone } from "react-dropzone";
import MicrosoftExcelIcon from "../../../../../assets/icons/microsoftExcel";
import { ButtonDelete } from "../../../../../components/common/Buttons";
import { AiOutlinePaperClip } from "react-icons/ai";

const ModalImportSupplier = ({ onClose }) => {
  const [uploadedFile, setUploadedFile] = React.useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    const acceptableMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    acceptedFiles.forEach((file) => {
      if (!acceptableMimeTypes.includes(file.type)) {
        return antdMessageError("Please upload an Excel file");
      }

      setUploadedFile(file);
    });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });
  const handleImport = () => {
    if (!uploadedFile) {
      return antdMessageError("Please upload a file before importing");
    }

    const formData = new FormData();
    formData.append("file", uploadedFile);

    mutationPOST.mutate(formData);
  };

  const handleDelete = () => {
    setUploadedFile(null);
  };

  const mutationPOST = useMutation({
    mutationFn: (value) =>
      Axios.post(`/api/v1/supplier_imports/`, value, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => res.data),
    onSuccess: (response) => {
      antdMessageInfo("Import is in progress");
      onClose();
    },
    onError: (error) => {
      antdMessageError();
    },
  });

  return (
    <ModalSpecial
      style={{
        width: 300,
      }}
      text={
        <span className="d-flex align-items-center justify-content-between w-100">
          <div>
            <span className="font-bold text-xl text-black">
              Suppliers import
            </span>
          </div>
        </span>
      }
      onClose={onClose}
    >
      <p style={{ color: "#1D1D1D", marginTop: 0, marginBottom: 10 }}>
        Import supplier information and link it to the corresponding products.
      </p>
      {uploadedFile && (
        <div
          className="d-flex flex-row justify-content-between"
          style={{
            border: "1px solid #D9D9D9",
            padding: 9,
            borderRadius: 4,
            marginBottom: 15,
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => window.open(URL.createObjectURL(uploadedFile))}
          >
            <AiOutlinePaperClip color="#00000073" />
            <p
              style={{
                margin: 0,
                color: "#03B0F7",
                textDecoration: "underline",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: 185,
              }}
            >
              {uploadedFile.name}
            </p>
          </div>
          <ButtonDelete onDelete={handleDelete} />
        </div>
      )}
      <p>
        Document <span style={{ color: "#03B0F7" }}>*</span>
      </p>
      <div {...getRootProps()}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            height: 75,
            backgroundColor: "#FAFAFA",
            border: "1px dashed #D9D9D9",
            borderRadius: 2,
            marginBottom: 10,
          }}
        >
          <input
            {...getInputProps()}
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
          {isDragActive ? (
            <p style={{ margin: 0, fontSize: 14 }}>Drop the file</p>
          ) : (
            <p style={{ margin: 0, fontSize: 14 }}>
              <FiUpload size={16} className="mr-2" /> Upload file here
            </p>
          )}
        </div>
      </div>
      <a href="/files/suppliers_import_file_sample.xlsx" download>
        <p
          className="align-items-center d-flex"
          style={{ color: "#03B0F7", textDecoration: "underline" }}
        >
          <MicrosoftExcelIcon className="mr-2" />
          Download XSLX sample
        </p>
      </a>
      <Button
        className="w-100"
        type="primary"
        htmlType="submit"
        loading={mutationPOST.isLoading}
        onClick={handleImport}
      >
        Import
      </Button>
    </ModalSpecial>
  );
};

export default ModalImportSupplier;
